/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import { Grid } from '@material-ui/core';
import { resultatWithColor } from '@orientaction/utils';
import clsx from 'clsx';
import { FC } from 'react';
import { useStyles } from './style';

interface IPodium {
  first: any;
  second: any;
  third: any;
  useForPDF?: boolean;
}

const Podium: FC<IPodium> = ({ first, second, third, useForPDF }) => {
  const classe = useStyles();
  return (
    <>
      <div
        className={clsx({
          [classe.withBorder]: true,
          [classe.root]: true,
        })}
      >
        <Grid container={true} direction="row" justifyContent="center" alignItems="flex-end">
          <Grid item={true}>
            <div
              className={clsx({
                [classe.second]: true,
                [classe.contentPodium]: true,
              })}
              style={{
                ...{ background: resultatWithColor[second?.key]?.color },
                ...(useForPDF && { width: '225px', height: '350px', fontSize: '30px', paddingTop: '40px' })
              }}
            >
              {second?.score || 0} {` `} <span className={classe.textFLoating} style={{ ...(useForPDF && { fontSize: '30px' }) }}>/100</span>
            </div>
          </Grid>
          <Grid item={true}>
            <div
              className={clsx({
                [classe.first]: true,
                [classe.contentPodium]: true,
              })}
              style={{
                ...{ background: resultatWithColor[first?.key]?.color },
                ...(useForPDF && { width: '225px', height: '455px', fontSize: '30px', paddingTop: '40px' })
              }}
            >
              {first?.score || 0}
              {` `}
              <span className={classe.textFLoating} style={{ ...(useForPDF && { fontSize: '30px' }) }}>/100</span>
            </div>
          </Grid>
          <Grid item={true}>
            <div
              className={clsx({
                [classe.third]: true,
                [classe.contentPodium]: true,
              })}
              style={{
                ...{ background: resultatWithColor[third?.key]?.color },
                ...(useForPDF && { width: '225px', height: '290px', fontSize: '30px', paddingTop: '40px' })
              }}
            >
              {third?.score || 0} {` `} <span className={classe.textFLoating} style={{ ...(useForPDF && { fontSize: '30px' }) }}>/100</span>
            </div>
          </Grid>
        </Grid>
      </div>

      <div
        className={clsx({
          [classe.root]: true,
        })}
      >
        <Grid container={true} direction="row" justifyContent="center" alignItems="flex-end">
          <Grid item={true}>
            <div
              className={clsx({
                [classe.titleContent]: true,
              })}
              style={{ ...(useForPDF && { fontSize: '25px', width: '225px' }) }}
            >
              {second?.label || ''}
            </div>
          </Grid>
          <Grid item={true}>
            <div
              className={clsx({
                [classe.titleContent]: true,
              })}
              style={{ ...(useForPDF && { fontSize: '25px', width: '225px' }) }}
            >
              <b>{first?.label || ''}</b>
            </div>
          </Grid>
          <Grid item={true}>
            <div
              className={clsx({
                [classe.titleContent]: true,
              })}
              style={{ ...(useForPDF && { fontSize: '25px', width: '225px' }) }}
            > 
              {third?.label || ''}
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Podium;
